import { StringifyOptions } from "querystring";
import { Generic } from "./chatbotmessage";
import { ESendBy } from "./EsendBy";

export class Message {
  constructor(public content: string, public sendBy: string,public source :string , public  data : Generic,public url : string , public location:string , public video :string , public num : number , public time?:string, public index?: number, public nbMessages?: number,public text?: string, public typeUser?: string, public image?:string)
   {}
}
